var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor)
        }
    }

    return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor
    }
}();

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i]
        }
        return arr2
    } else {
        return Array.from(arr)
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function')
    }
}

window.mobileCheck = function () {
    var check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true
        }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check
};
window.mobileAndTabletCheck = function () {
    var check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true
        }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check
};

function throttle(func, limit) {
    var inThrottle = void 0;
    return function () {
        if (!inThrottle) {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key]
            }
            func.apply(this, args);
            inThrottle = true;
            setTimeout(function () {
                return inThrottle = false
            }, limit)
        }
    }
}

function getScrollbarWidth() {
    var outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    outer.style.height = '100px';
    outer.style.overflow = 'scroll';
    document.body.appendChild(outer);
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '100%';
    outer.appendChild(inner);
    var widthDiff = outer.offsetWidth - inner.offsetWidth;
    outer.remove();
    return widthDiff
}

function lockScrollbar() {
    var scrollbarWidth = getScrollbarWidth();
    document.body.style.overflow = 'hidden';
    document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px')
}

function unlockScrollbar() {
    document.body.style.overflow = 'visible';
    document.documentElement.style.removeProperty('--scrollbar-width')
}// Form validation module
var FormValidator = function () {
    function FormValidator(formElementOrSelector) {
        _classCallCheck(this, FormValidator);
        if (!formElementOrSelector) {
            return
        }
        this.form = typeof formElementOrSelector === 'string' ? document.querySelector(formElementOrSelector) : formElementOrSelector;
        if (!this.form) {
            return
        }
        this.fields = Array.from(this.form.querySelectorAll('.js-form-field'));
        this.upload_files = [];
        this.bindEvents();
        this.initUploads()
    }

    _createClass(FormValidator, [{
        key: 'bindEvents', value: function bindEvents() {
            var _this = this;
            this.form.addEventListener('submit', function (e) {
                return _this.handleSubmit(e)
            })
        }
    }, {
        key: 'handleSubmit', value: function handleSubmit(e) {
            if (!this.validateAllFields()) {
                e.preventDefault()
            }
        }
    }, {
        key: 'validateAllFields', value: function validateAllFields() {
            var _this2 = this;
            var validationResults = this.fields.map(function (field) {
                return _this2.validateField(field)
            });
            return validationResults.every(Boolean)
        }
    }, {
        key: 'validateField', value: function validateField(field) {
            var input = field.querySelector('.js-form-input');
            var error = field.querySelector('.js-form-field-error');
            var value = input.value.trim();
            this.resetFieldState(field, input, error);
            if (input.type === 'file') {
                var hasFiles = this.upload_files.length > 0;
                if (!hasFiles) {
                    return this.handleEmptyField(field, input, error)
                }
                return true
            }
            if (!value) {
                return this.handleEmptyField(field, input, error)
            }
            return this.validatePattern(field, input, error, value)
        }
    }, {
        key: 'resetFieldState', value: function resetFieldState(field, input, error) {
            field.classList.remove('_error');
            input.classList.remove('_error');
            if (error) {
                error.textContent = ''
            }
        }
    }, {
        key: 'handleEmptyField', value: function handleEmptyField(field, input, error) {
            var emptyError = field.dataset.emptyError;
            if (!emptyError) {
                return true
            }
            field.classList.add('_error');
            input.classList.add('_error');
            if (error && emptyError) {
                this.showError(error, emptyError)
            }
            return false
        }
    }, {
        key: 'validatePattern', value: function validatePattern(field, input, error, value) {
            var patternAttr = input.dataset.pattern;
            if (!patternAttr) {
                return true
            }
            var pattern = new RegExp(patternAttr);
            var patternError = field.dataset.patternError;
            if (!pattern.test(value)) {
                input.classList.add('_error');
                if (error && patternError) {
                    this.showError(error, patternError)
                }
                return false
            }
            return true
        }
    }, {
        key: 'showError', value: function showError(errorElement, errorMessage) {
            errorElement.textContent = errorMessage;
            errorElement.style.display = 'block'
        }// Uploader Logic
    }, {
        key: 'validationFiles', value: function validationFiles(files) {
            var _this3 = this;
            var validatedFiles = [];
            var extensions = ['jpeg', 'jpg', 'png', 'JPEG', 'JPG', 'PNG'];
            var maxSize = 5;
            var maxFiles = 10;
            files.forEach(function (file) {
                var extension = file.name.split('.').pop();
                var size = file.size / (1000 * 1000);
                if (extensions.includes(extension) && size <= maxSize) {
                    validatedFiles.push(file);
                    var errorElement = _this3.form.querySelector('.form-uploader-error');
                    errorElement.style.display = 'none'
                }
                if (size > maxSize) {
                    _this3.showFileError(file.name)
                }
            });
            return validatedFiles.slice(0, maxFiles)
        }
    }, {
        key: 'showFileError', value: function showFileError(name) {
            var errorElement = this.form.querySelector('.form-uploader-error');
            errorElement.querySelector('.name').textContent = name;
            errorElement.style.display = 'block'
        }
    }, {
        key: 'uploadFile', value: function uploadFile(upload, file) {
            var _this4 = this;
            var list = upload.querySelector('.form-uploader-files');
            var input = upload.querySelector('input[name="files"]');
            var el = document.createElement('div');
            var elImage = document.createElement('div');
            var elImageFile = document.createElement('img');
            var elRemove = document.createElement('div');
            el.classList.add('file');
            elImage.classList.add('file-image');
            elImageFile.src = URL.createObjectURL(file);
            elRemove.classList.add('file-remove');
            elRemove.innerHTML = '<span class="icon icon-trash-2"></span>';
            list.appendChild(el);
            el.appendChild(elImage);
            elImage.appendChild(elImageFile);
            el.appendChild(elRemove);
            this.upload_files.push(file.name);
            input.value = this.upload_files.join(' ');
            elRemove.addEventListener('click', function () {
                el.remove();
                var position = _this4.upload_files.indexOf(file.name);
                if (position >= 0) {
                    _this4.upload_files.splice(position, 1)
                }
                input.value = _this4.upload_files.join(' ')
            })
        }
    }, {
        key: 'uploadFiles', value: function uploadFiles(upload, files) {
            var _this5 = this;
            var validatedFiles = this.validationFiles([].concat(_toConsumableArray(files)));
            validatedFiles.forEach(function (file) {
                return _this5.uploadFile(upload, file)
            })
        }
    }, {
        key: 'initUploads', value: function initUploads() {
            var _this6 = this;
            var uploads = document.querySelectorAll('.form-uploader');
            var events = ['dragenter', 'dragover', 'dragleave', 'drop'];
            uploads && uploads.length && uploads.forEach(function (upload) {
                var input = upload.querySelector('input[type="file"]');
                events.forEach(function (event) {
                    upload.addEventListener(event, function (e) {
                        e.preventDefault();
                        e.stopPropagation()
                    })
                });
                upload.addEventListener('drop', function (e) {
                    _this6.uploadFiles(upload, e.dataTransfer.files)
                });
                input.addEventListener('change', function (e) {
                    _this6.uploadFiles(upload, input.files)
                }, {passive: true})
            })
        }
    }]);
    return FormValidator
}();// Accordion
var Accordion = function () {
    function Accordion(accordionOrSelector) {
        _classCallCheck(this, Accordion);
        this.accordion = typeof accordionOrSelector === 'string' ? document.querySelectorAll('.js-accordion') : accordionOrSelector;
        if (!this.accordion) {
            return
        }
        this.init()
    }

    _createClass(Accordion, [{
        key: 'init', value: function init() {
            this.setupAccordionItems(this.accordion)
        }
    }, {
        key: 'setupAccordionItems', value: function setupAccordionItems(accordion) {
            var items = accordion.querySelectorAll('.js-accordion-item');
            items.forEach(function (item) {
                var trigger = item.querySelector('.js-accordion-trigger');
                if (trigger) {
                    trigger.addEventListener('click', function () {
                        item.classList.toggle('_open')
                    })
                }
            })
        }
    }]);
    return Accordion
}();// === Header
// === Header menu
var HeaderMenu = function () {
    function HeaderMenu() {
        _classCallCheck(this, HeaderMenu);
        this.header = document.querySelector('.header');
        this.menu = document.querySelector('.js-header-nav');
        if (!this.menu) {
            return
        }
        this.init()
    }

    _createClass(HeaderMenu, [{
        key: 'init', value: function init() {
            this.cacheElements();
            this.bindEvents();
            this.state = {
                isLocked: false, activeItem: this.menuItems.find(function (item) {
                    return item.classList.contains('_active')
                })
            }
        }
    }, {
        key: 'cacheElements', value: function cacheElements() {
            this.triggerBtn = document.querySelector('.js-header-nav-btn');
            this.menuItems = Array.from(this.menu.querySelectorAll('.js-header-nav-item'));
            this.menus = Array.from(this.menu.querySelectorAll('.js-header-nav-menu'));
            this.menuLinks = Array.from(this.menu.querySelectorAll('.js-header-nav-link'));
            this.submenuFocusableItems = this.menus.flatMap(function (menu) {
                return Array.from(menu.querySelectorAll('a, button'))
            })
        }
    }, {
        key: 'setSubmenuFocus', value: function setSubmenuFocus(enabled) {
            this.submenuFocusableItems.forEach(function (el) {
                if (enabled) {
                    el.setAttribute('tabindex', '0')
                } else {
                    el.setAttribute('tabindex', '-1')
                }
            })
        }
    }, {
        key: 'bindEvents', value: function bindEvents() {
            var _this7 = this;
            this.triggerBtn.addEventListener('click', function () {
                return _this7.handleMenuToggle()
            });
            this.menu.addEventListener('mousemove', throttle(this.handleMouseMove.bind(this), 16));
            this.menu.addEventListener('mouseleave', function () {
                if (_this7.header.classList.contains('_pc-nav-open')) {
                    return
                }
                _this7.closeMenu()
            });
            window.addEventListener('click', function (event) {
                var clickTarget = event.target;// console.log( 'clickTarget: ', clickTarget );
                if (!_this7.triggerBtn.contains(clickTarget) && !_this7.menu.contains(clickTarget) || clickTarget.classList.contains('js-header-nav-menu')) {
                    _this7.closeMenu()
                }
            });
            window.addEventListener('scroll', function () {
                return _this7.closeMenu()
            });
            window.addEventListener('resize', function () {
                return _this7.closeMenu()
            });
            this.menuLinks.forEach(function (link) {
                link.addEventListener('keydown', function (event) {
                    if (event.key === 'Enter') {
                        var targetItem = link.closest('.js-header-nav-item');
                        if (!_this7.header.classList.contains('_pc-nav-open')) {
                            _this7.handleMenuToggle()
                        }
                        _this7.updateActiveItem(targetItem)
                    }
                })
            })
        }
    }, {
        key: 'handleMenuToggle', value: function handleMenuToggle() {
            if (this.state.isLocked) {
                return
            }
            this.state.isLocked = true;
            var isOpen = this.header.classList.contains('_pc-nav-open');
            this.toggleMenuState(isOpen);
            this.updateMenuPosition(isOpen);
            if (isOpen) {
                this.menuItems.forEach(function (menuItem) {
                    return menuItem.classList.remove('_active')
                })
            }
        }
    }, {
        key: 'toggleMenuState', value: function toggleMenuState(isOpen) {
            var _this8 = this;
            this.header.classList.toggle('_pc-nav-open');
            this.triggerBtn.classList.toggle('_active');
            setTimeout(function () {
                _this8.menu.classList.toggle('_active');
                _this8.state.isLocked = false;
                _this8.setSubmenuFocus(true);
                _this8.updateMenuPosition(isOpen)
            }, isOpen ? 0 : 400)
        }
    }, {
        key: 'updateMenuPosition', value: function updateMenuPosition(isOpen) {
            var menu = document.querySelector('.js-header-nav');
            var topPosition = this.header.offsetHeight - 1 + 'px';
            this.menus.forEach(function (menu) {
                if (!isOpen) {// menu.style.top = topPosition;
                } else {
                    menu.removeAttribute('style')
                }
            });// const topPosition = isOpen ? '0' : `${menu.clientHeight}px`;
// this.menus.forEach( menu => {
// 	menu.style.top = topPosition;
// });
        }
    }, {
        key: 'handleMouseMove', value: function handleMouseMove(event) {
            if (window.innerWidth < 1200) {
                return
            }
            var targetItem = event.target.closest('.js-header-nav-item');
            if (this.shouldSkipMouseMove(targetItem)) {
                return
            }
            this.updateActiveItem(targetItem)
        }
    }, {
        key: 'shouldSkipMouseMove', value: function shouldSkipMouseMove(targetItem) {
            return !targetItem;// return (
// 	!targetItem ||
// 	( this.state.activeItem && targetItem === this.state.activeItem )
// );
        }
    }, {
        key: 'updateActiveItem', value: function updateActiveItem(newItem) {
            if (this.state.activeItem) {
                this.state.activeItem.classList.remove('_active')
            }
            if (newItem) {
                newItem.classList.add('_active');
                this.state.activeItem = newItem
            } else {
                this.state.activeItem = null
            }
        }
    }, {
        key: 'closeMenu', value: function closeMenu() {
            this.menus.forEach(function (menu) {
                return menu.removeAttribute('style')
            });
            this.header.classList.remove('_pc-nav-open');
            this.triggerBtn.classList.remove('_active');
            this.setSubmenuFocus(false);
            if (this.state.activeItem) {
                this.state.activeItem.classList.remove('_active');
                this.state.activeItem = null
            }
        }
    }]);
    return HeaderMenu
}();// === Mobile menu
var MobileNavMenu = function () {
    function MobileNavMenu() {
        _classCallCheck(this, MobileNavMenu);
        this.mobileMenu = document.querySelector('.js-mobile-nav');
        if (!this.mobileMenu) {
            return
        }
        this.init()
    }

    _createClass(MobileNavMenu, [{
        key: 'init', value: function init() {
            this.cacheElements();
            this.setupInitialState();
            this.bindEvents()
        }
    }, {
        key: 'cacheElements', value: function cacheElements() {
            this.mobileMenuOpen = document.querySelector('.js-mobile-nav-open');
            this.mobileMenuClose = document.querySelector('.js-mobile-nav-close');
            this.mobileMenuNavBtns = Array.from(this.mobileMenu.querySelectorAll('.js-mobile-nav-button'));
            this.mobileMenuLists = Array.from(this.mobileMenu.querySelectorAll('.js-mobile-nav-list'));
            this.navOpenClass = '_is-open';
            this.navListActiveClass = '_active'
        }
    }, {
        key: 'setupInitialState', value: function setupInitialState() {
            var _this9 = this;
            this.activeList = this.mobileMenuLists.find(function (list) {
                return list.classList.contains(_this9.navListActiveClass)
            });
            if (!this.activeList) {
                this.activeList = this.mobileMenuLists[0];
                if (this.activeList) {
                    this.activeList.classList.add(this.navListActiveClass)
                }
            }
        }
    }, {
        key: 'bindEvents', value: function bindEvents() {
            var _this10 = this;
            this.mobileMenu.addEventListener('click', function (event) {
                if (event.target === event.currentTarget) {
                    _this10.closeMobileMenu()
                }
            });
            this.mobileMenuOpen.addEventListener('click', function () {
                return _this10.openMobileMenu()
            });
            this.mobileMenuClose.addEventListener('click', function () {
                return _this10.closeMobileMenu()
            });
            this.mobileMenuNavBtns.forEach(function (btn) {
                btn.addEventListener('click', function (event) {
                    return _this10.handleNavButtonClick(event)
                })
            })
        }
    }, {
        key: 'openMobileMenu', value: function openMobileMenu() {
            this.mobileMenu.classList.add(this.navOpenClass);
            lockScrollbar()
        }
    }, {
        key: 'closeMobileMenu', value: function closeMobileMenu() {
            this.mobileMenu.classList.remove(this.navOpenClass);
            unlockScrollbar()
        }
    }, {
        key: 'handleNavButtonClick', value: function handleNavButtonClick(event) {
            var btn = event.currentTarget;
            if (btn.tagName === 'A') {
                return
            }
            var targetId = btn.dataset.target;
            if (!targetId) {
                return
            }
            var targetList = this.mobileMenuLists.find(function (list) {
                return list.id === targetId
            });
            if (!targetList) {
                return
            }
            if (this.activeList === targetList) {
                return
            }
            if (this.activeList) {
                this.activeList.classList.remove(this.navListActiveClass)
            }
            targetList.classList.add(this.navListActiveClass);
            this.activeList = targetList
        }
    }]);
    return MobileNavMenu
}();// === Product card
var ProductCard = function () {
    function ProductCard(cardOrSelector) {
        _classCallCheck(this, ProductCard);
        this.card = typeof cardOrSelector === 'string' ? document.querySelector(cardOrSelector) : cardOrSelector;
        if (!this.card) {
            return
        }
        this.wishButton = this.card && this.card.querySelector('.js-product-card-wish');
        if (!this.wishButton) {
            return
        }
        this.init()
    }

    _createClass(ProductCard, [{
        key: 'init', value: function init() {
            if (this.wishButton) {
                this.wishButton.addEventListener('click', this.handleWishButtonClick.bind(this))
            }
        }
    }, {
        key: 'handleWishButtonClick', value: function handleWishButtonClick() {
            this.wishButton.classList.toggle('_is-in-with')
        }
    }]);
    return ProductCard
}();// === Tabs
var Tabs = function () {
    function Tabs() {
        _classCallCheck(this, Tabs);
        this.activeClass = '_active';
        this.bindEvents()
    }

    _createClass(Tabs, [{
        key: 'bindEvents', value: function bindEvents() {
            var _this11 = this;
            document.addEventListener('click', function (event) {
                var button = event.target.closest('.js-tabs-button');
                if (!button) {
                    return
                }
                _this11.handleTabButtonClick(button)
            })
        }
    }, {
        key: 'handleTabButtonClick', value: function handleTabButtonClick(button) {
            var _this12 = this;// Якщо кнопка вже активна, нічого не робимо
            if (button.classList.contains(this.activeClass)) {
                return
            }
            var tabs = button.closest('.js-tabs');// Знаходимо батьківський блок .js-tabs
            if (!tabs) {
                return
            }
            var tabId = button.dataset.tabId;// Отримуємо ID таба
            var triggers = tabs.querySelectorAll('.js-tabs-button');// Всі кнопки в межах поточного блоку .js-tabs
            var contents = tabs.querySelectorAll('.js-tabs-tab');// Весь контент в межах поточного блоку .js-tabs
// Знімаємо активний клас з усіх кнопок і контенту
            triggers.forEach(function (trigger) {
                return trigger.classList.remove(_this12.activeClass)
            });
            contents.forEach(function (content) {
                return content.classList.remove(_this12.activeClass)
            });// Додаємо активний клас до поточної кнопки
            button.classList.add(this.activeClass);// Показуємо відповідний контент
            var newContent = tabs.querySelector('.js-tabs-tab[data-tab-id="' + tabId + '"]');
            if (newContent) {
                newContent.classList.add(this.activeClass)
            }
        }
    }]);
    return Tabs
}();// === Header
// Measure the FULL (un-scrolled) header height and write it to --header-height.
// The header shrinks in the _scrolled state; measuring it directly during a
// resize would bake the shrunken height into the var and content would slide
// under the fixed header after scrolling back to top. We temporarily disable
// transitions (._measuring) and lift _scrolled for one synchronous layout read —
// the browser never paints in between, so there is no flicker.
function recalcHeaderHeightVar(headerEl) {
    var header = headerEl || document.querySelector('.header');
    if (!header) {
        return
    }
    var wasScrolled = header.classList.contains('_scrolled');
    header.classList.add('_measuring');
    if (wasScrolled) {
        header.classList.remove('_scrolled')
    }
    var headerHeight = header.clientHeight;
    var mobileOnlyHeader = document.querySelector('.header-top');
    var mobileHeight = mobileOnlyHeader ? mobileOnlyHeader.clientHeight : 0;
    if (wasScrolled) {
        header.classList.add('_scrolled')
    }
    header.classList.remove('_measuring');
    if (!headerHeight) {
        return
    }
    document.documentElement.style.setProperty('--header-height', headerHeight - 1 + 'px');
    if (mobileHeight) {
        document.documentElement.style.setProperty('--header-mobile-height', mobileHeight - 1 + 'px')
    }
}
var Header = function () {
    function Header() {
        _classCallCheck(this, Header);
        this.header = document.querySelector('.js-header');
        if (!this.header) {
            return
        }
        this.init()
    }

    _createClass(Header, [{
        key: 'init', value: function init() {
            var _this13 = this;
            this.handleHeaderOnWindowScroll();
            setTimeout(function () {
                _this13.handleHeaderOnWindowResize()
            }, 50)
        }
    }, {
        key: 'handleHeaderOnWindowScroll', value: function handleHeaderOnWindowScroll() {
            var headerHeight = this.header.clientHeight || 0;
            if (window.scrollY > headerHeight) {
                this.header.classList.add('_scrolled');
                if (document.querySelector('.product')) {
                    document.querySelector('.product').classList.add('_scrolled-header')
                }
                if (document.querySelector('.login-page')) {
                    this.header.classList.add('_scrolled')
                }
            } else {
                if (document.querySelector('.login-page')) {
                    this.header.classList.add('_scrolled')
                } else {
                    this.header.classList.remove('_scrolled')
                }
                if (document.querySelector('.product')) {
                    document.querySelector('.product').classList.remove('_scrolled-header')
                }
            }
        }
    }, {
        key: 'handleHeaderOnWindowResize', value: function handleHeaderOnWindowResize() {
            var _this14 = this;
            requestAnimationFrame(function () {
                recalcHeaderHeightVar(_this14.header)
            })
        }
    }]);
    return Header
}();
window.addEventListener('load', function () {// === Initialize components
// Header
    var header = new Header;// Header menu
    new HeaderMenu;
    var submenuItems = document.querySelectorAll('.js-header-nav-menu a, .js-header-nav-menu button');
    submenuItems.forEach(function (item) {
        item.setAttribute('tabindex', '-1')
    });// Mobile menu
    var mobileNavMenu = new MobileNavMenu;// Accordions
    var accordions = document.querySelectorAll('.js-accordion');
    if (accordions.length) {
        accordions.forEach(function (accordion) {
            new Accordion(accordion)
        })
    }// ProductCards
    var productCards = document.querySelectorAll('.js-product-card');
    if (productCards.length) {
        productCards.forEach(function (card) {
            new ProductCard(card)
        })
    }// Forms
    var forms = document.querySelectorAll('.js-form');
    if (forms.length) {
        forms.forEach(function (form) {
            new FormValidator(form)
        })
    }// Tabs
    new Tabs;// === Initialize sliders
// Main hero slider
    var heroSliderEl = document.querySelector('.js-main-hero-slider');
    if (heroSliderEl) {
        var heroHasMultiple = heroSliderEl.querySelectorAll('.swiper-slide').length > 1;
        new Swiper(heroSliderEl, {
            slidesPerView: 1,
            speed: 1000,
            loop: heroHasMultiple,
            allowTouchMove: heroHasMultiple,
            autoplay: heroHasMultiple ? {delay: 5000, disableOnInteraction: false} : false,
            pagination: heroHasMultiple ? {el: '.main-hero-slider-pagination', clickable: true} : false,
            navigation: false,
            breakpoints: {1024: {allowTouchMove: false}}
        });
    }// Header menu sliders
    var headerSlidersInMenu = document.querySelectorAll('.js-header-nav-menu-slider-wrapper');
    if (headerSlidersInMenu.length) {
        headerSlidersInMenu.forEach(function (wrapper) {
            var slider = wrapper.querySelector('.js-header-nav-menu-slider');
            var counter = wrapper.querySelector('.js-header-nav-menu-slider-counter');
            var counterCurrent = counter.querySelector('.js-current');
            var counterTotal = counter.querySelector('.js-total');
            var prevBtn = wrapper.querySelector('.js-header-nav-menu-slider-prev');
            var nextBtn = wrapper.querySelector('.js-header-nav-menu-slider-next');
            new Swiper(slider, {
                loop: false,
                slidesPerView: 1,
                speed: 1000,
                spaceBetween: 10,
                navigation: {prevEl: prevBtn, nextEl: nextBtn},
                on: {
                    init: function init() {
                        var swiper = this.slides;
                        if (swiper) {
                            counterTotal.textContent = this.slides.length;
                            counterCurrent.textContent = this.activeIndex + 1
                        }
                    }, slideChange: function slideChange() {
                        var swiper = this.slides;
                        if (swiper) {
                            counterCurrent.textContent = this.activeIndex + 1
                        }
                    }
                }
            })
        })
    }// Tabs slider
// Tabs slider
    var tabsSwipers = [];

    function initOrDestroyTabsSliders() {
        var tabsSliders = document.querySelectorAll('.js-tabs-btns');
        if (!tabsSliders.length) {
            return
        }
        tabsSliders.forEach(function (tabsWrapper, index) {
            var slider = tabsWrapper.querySelector('.js-tabs-btn-slider');
            var prevButton = tabsWrapper.querySelector('.js-tabs-prev');
            var nextButton = tabsWrapper.querySelector('.js-tabs-next');
            if (window.innerWidth >= 1024) {
                if (!tabsSwipers[index]) {
                    tabsSwipers[index] = new Swiper(slider, {
                        speed: 300,
                        slidesPerView: 'auto',
                        spaceBetween: 6,
                        loop: false,
                        navigation: {prevEl: prevButton, nextEl: nextButton}
                    })
                }
            } else {
                if (tabsSwipers[index]) {
                    tabsSwipers[index].destroy(true, true);
                    tabsSwipers[index] = null;
                    tabsWrapper.querySelectorAll('.js-tabs-button').forEach(function (button) {
                        button.removeAttribute('tabindex')
                    })
                }
            }
        })
    }// News slider
    new Swiper('.js-news-slider', {
        loop: false,
        slidesPerView: 1.175,
        spaceBetween: 10,
        speed: 1000,
        navigation: {nextEl: null, prevEl: null},
        breakpoints: {
            576: {slidesPerView: 1.175},
            768: {slidesPerView: 2.5},
            1200: {slidesPerView: 3.1, spaceBetween: 14}
        }
    });// Instagram slider
    var instagramSwiper = null;

    function initInstagramSlider() {
        var slider = document.querySelector('.js-instagram-slider');
        if (window.innerWidth >= 768 && slider) {
            if (!instagramSwiper) {
                instagramSwiper = new Swiper(slider, {
                    loop: false,
                    speed: 300,
                    slidesPerView: 'auto',
                    spaceBetween: 4,
                    navigation: {nextEl: null, prevEl: null}
                })
            }
        } else {
            if (instagramSwiper) {
                instagramSwiper.destroy(true, true);
                instagramSwiper = null
            }
        }
    }// ==== Common listeners
    window.addEventListener('scroll', throttle(function () {
        header.handleHeaderOnWindowScroll()
    }, 16));
    initOrDestroyTabsSliders();
    initInstagramSlider();
    window.addEventListener('resize', throttle(function () {
        if (window.innerWidth > 1024) {
            header.handleHeaderOnWindowResize()
        }
        initOrDestroyTabsSliders();
        initInstagramSlider()
    }, 100));//search popup
    var openerSearch = document.querySelectorAll('.js-header-opener-search');
    if (openerSearch.length) {
        var searchPopup = document.querySelector('.search-popup');
        var searchPopupClose = searchPopup.querySelectorAll('.js-search-popup-close');
        var searchPopupInput = searchPopup.querySelector('input.search-field-input');
        openerSearch.forEach(function (btn) {
            btn.addEventListener('click', function () {
                searchPopup.classList.add('open');
                mobileNavMenu.closeMobileMenu();
                setTimeout(function () {
                    searchPopupInput.focus()
                }, 301);
                lockScrollbar()
            })
        });
        searchPopupClose.forEach(function (item) {
            item.addEventListener('click', function () {
                searchPopup.classList.remove('open');
                unlockScrollbar()
            })
        })
    }//search clean
    var searchField = document.querySelectorAll('.search-field');
    if (searchField.length) {
        searchField.forEach(function (item) {
            var searchClear = item.querySelector('.search-field-clean');
            var fieldInput = item.querySelector('input.search-field-input');
            searchClear.addEventListener('click', function () {
                fieldInput.value = '';
                fieldInput.focus()
            });
            fieldInput.addEventListener('focus', function () {
                fieldInput.parentElement.classList.add('focus')
            });
            fieldInput.addEventListener('blur', function () {
                fieldInput.parentElement.classList.remove('focus')
            });
            fieldInput.addEventListener('input', function () {
                if (fieldInput.value.trim() !== '') {
                    fieldInput.parentElement.classList.add('value')
                } else {
                    fieldInput.parentElement.classList.remove('value')
                }
            })
        })
    }//search clean
    var promocodeField = document.querySelector('.discount-code-form');
    if (promocodeField) {
        var promocodeFieldInput = promocodeField.querySelector('input');
        var promocodeFieldBtn = promocodeField.querySelector('.btn');
        promocodeFieldInput.addEventListener('input', function () {
            if (promocodeFieldInput.value.trim() !== '') {
                promocodeFieldBtn.classList.remove('_disabled')
            } else {
                promocodeFieldBtn.classList.add('_disabled')
            }
        })
    }
    var categorySectionSlider = document.querySelector('.collection-category-swiper');
    if (categorySectionSlider) {
        var wrapper = categorySectionSlider.querySelector('.swiper-wrapper');
        var container = categorySectionSlider.closest('.container');
        var prevBtn = document.querySelector('.swiper-button-prev');
        var nextBtn = document.querySelector('.swiper-button-next');
        var swiperSlides = categorySectionSlider.querySelectorAll('.swiper-slide');
        var checkOverflowAndInitSwiper = function checkOverflowAndInitSwiper() {
            swiperSlides.forEach(function (slide) {
                slide.style.marginRight = '23px'
            });
            var wrapperWidth = wrapper.scrollWidth;
            var containerWidth = container.clientWidth;// Destroy previous instance if exists
            if (categorySectionSlider.swiper) {
                categorySectionSlider.swiper.destroy(true, true)
            }
            if (wrapperWidth <= containerWidth) {// Center slides, hide arrows
                wrapper.style.justifyContent = 'center';
                prevBtn.style.display = 'none';
                nextBtn.style.display = 'none';// swiperSlides.forEach( slide => {
// 	slide.style.marginRight = '23px';
// });
            } else {// Left-align, show arrows
                if (window.innerWidth > 768) {
                    wrapper.style.justifyContent = 'start';
                    prevBtn.style.display = 'flex';
                    nextBtn.style.display = 'flex';
                    swiperSlides.forEach(function (slide) {
                        slide.style.marginRight = '0'
                    });
                } else {
                    wrapper.style.justifyContent = 'flex-start';
                    prevBtn.style.display = 'none';
                    nextBtn.style.display = 'none'
                }

                var swiper = new Swiper(categorySectionSlider, {
                    slidesPerView: 'auto',
                    spaceBetween: 23,
                    speed: 300,
                    loop: false,
                    breakpoints: {
                        0: {
                            navigation: false
                        },
                        768: {
                            navigation: {nextEl: nextBtn, prevEl: prevBtn},
                        },
                    },
                    on: {
                        init: function init() {
                            var activeSlide = categorySectionSlider.querySelector('.swiper-slide.is-active');
                            if (activeSlide) {
                                var activeIndex = Array.from(swiperSlides).indexOf(activeSlide);
                                if (activeIndex > 0) this.slideTo(activeIndex, 0)
                            }
                            if (window.innerWidth < 768) return;
                            updateArrowVisibility(this)
                        }, slideChange: function slideChange() {
                            if (window.innerWidth < 768) return;
                            updateArrowVisibility(this)
                        }, reachBeginning: function reachBeginning() {
                            if (window.innerWidth < 768) return;
                            prevBtn.style.opacity = '0';
                            prevBtn.style.pointerEvents = 'none'
                        }, fromEdge: function fromEdge() {
                            if (window.innerWidth < 768) return;
                            updateArrowVisibility(this)
                        }, reachEnd: function reachEnd() {
                            if (window.innerWidth < 768) return;
                            nextBtn.style.opacity = '0';
                            nextBtn.style.pointerEvents = 'none'
                        }
                    }
                })
            }
            // Reveal the block whether or not Swiper was initialized
            // (when content fits the container, Swiper is skipped).
            categorySectionSlider.classList.add('is-ready');
        };
        var updateArrowVisibility = function updateArrowVisibility(swiper) {
            if (swiper.isBeginning) {
                prevBtn.style.opacity = '0';
                prevBtn.style.pointerEvents = 'none'
            } else {
                prevBtn.style.opacity = '1';
                prevBtn.style.pointerEvents = 'auto'
            }
            if (swiper.isEnd) {
                nextBtn.style.opacity = '0';
                nextBtn.style.pointerEvents = 'none'
            } else {
                nextBtn.style.opacity = '1';
                nextBtn.style.pointerEvents = 'auto'
            }
        };
        setTimeout(function () {
            checkOverflowAndInitSwiper()
        }, 100);
        window.addEventListener('resize', checkOverflowAndInitSwiper)
    }
});

function createInlineReadMore(_ref) {
    var elementId = _ref.elementId, _ref$maxChars = _ref.maxChars,
        maxChars = _ref$maxChars === undefined ? 122 : _ref$maxChars, _ref$readMoreText = _ref.readMoreText,
        readMoreText = _ref$readMoreText === undefined ? window.translations.view_more : _ref$readMoreText,
        _ref$readLessText = _ref.readLessText,
        readLessText = _ref$readLessText === undefined ? window.translations.view_less : _ref$readLessText,
        _ref$mobileMaxChars = _ref.mobileMaxChars,
        mobileMaxChars = _ref$mobileMaxChars === undefined ? 100 : _ref$mobileMaxChars,
        _ref$mobileBreakpoint = _ref.mobileBreakpoint,
        mobileBreakpoint = _ref$mobileBreakpoint === undefined ? 768 : _ref$mobileBreakpoint;
    var container = document.getElementById(elementId);
    if (!container) {
        return
    }
    if (container.classList.contains('no-truncate') && window.innerWidth >= 768) {
        return
    }
    // A description with links cannot be cut by characters - the cut rebuilds it from textContent and the
    // links are gone. Clamp it by lines instead and keep the markup.
    if (container.querySelector('a')) {
        container.classList.add('is-clamped');
        if (container.scrollHeight <= container.clientHeight + 2) {
            container.classList.remove('is-clamped');
            return
        }
        var toggle = document.createElement('span');
        toggle.className = 'read-more-toggle non-expanded';
        toggle.textContent = readMoreText;
        container.insertAdjacentElement('afterend', toggle);
        toggle.onclick = function () {
            var clamped = container.classList.toggle('is-clamped');
            toggle.textContent = clamped ? readMoreText : readLessText;
            toggle.className = clamped ? 'read-more-toggle non-expanded' : 'read-more-toggle expanded';
        };
        return
    }
    var text = container.textContent;
    var isMobile = function isMobile() {
        return window.innerWidth < mobileBreakpoint
    };
    var getMaxChars = function getMaxChars() {
        return isMobile() ? mobileMaxChars : maxChars
    };
    var render = function render() {
        var chars = getMaxChars();
        if (text.length <= chars) {
            container.textContent = text;
            return
        }
        var visibleText = text.slice(0, chars).trim();
        var hiddenText = text.slice(chars).trim();
        container.innerHTML = '\n      ' + visibleText + '<span class="ellipsis">...</span>\n      <span class="hidden-text" id="' + elementId + '-more" style="display: none;">' + hiddenText + '</span>\n      <span class="read-more-toggle non-expanded" id="' + elementId + '-btn">' + readMoreText + '</span>\n    ';
        var btn = document.getElementById(elementId + '-btn');
        var more = document.getElementById(elementId + '-more');
        var ellipsis = container.querySelector('.ellipsis');
        btn.onclick = function () {
            var expanded = more.style.display === 'inline';
            more.style.display = expanded ? 'none' : 'inline';
            ellipsis.style.display = expanded ? 'inline' : 'none';
            btn.textContent = expanded ? readMoreText : readLessText;
            btn.className = expanded ? 'read-more-toggle non-expanded' : 'read-more-toggle expanded';
            btn.style.display = expanded ? 'inline' : 'flex'
        }
    };
    render();
    window.addEventListener('resize', function () {
        container.innerHTML = '';
        render()
    })
}

createInlineReadMore({elementId: 'inlineReadMore', maxChars: 130, mobileMaxChars: 98});

// Swiper for subcategories (mobile only)
(function() {
    if (window.innerWidth >= 768) return;
    var container = document.querySelector('.collection-header-wrapper-subcategories');
    if (!container) return;
    var items = Array.from(container.children);
    container.classList.add('swiper-container');
    var wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';
    items.forEach(function(item) {
        var slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.style.width = 'auto';
        slide.appendChild(item);
        wrapper.appendChild(slide);
    });
    var scrollbar = document.createElement('div');
    scrollbar.className = 'swiper-scrollbar subcategories-scrollbar';
    container.innerHTML = '';
    container.appendChild(wrapper);
    container.appendChild(scrollbar);
    new Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: 6,
        freeMode: true,
        grabCursor: true,
        mousewheel: { forceToAxis: true },
        scrollbar: { el: scrollbar, draggable: false, hide: false },
    });
})();


window.addEventListener('load', function () {
    var collectionHeaderSlider = document.querySelector('.collection-header-wrapper-content-right-slider-container.swiper-container');
    if (collectionHeaderSlider) {
        var collectionSliderInstance = new Swiper(collectionHeaderSlider, {
            slidesPerView: 'auto',
            spaceBetween: 15,
            speed: 800,
            navigation: {
                nextEl: '.collection-header-wrapper .swiper-button-next',
                prevEl: '.collection-header-wrapper .swiper-button-prev'
            }
        })
    }
});
document.addEventListener('DOMContentLoaded', function () {
    var customSelect = document.querySelector('.custom-select-wrapper');
    if (customSelect) {
        var selected = customSelect.querySelector('.selected-option');
        var options = customSelect.querySelectorAll('.options li');
        selected.addEventListener('click', function () {
            customSelect.classList.toggle('open')
        });
        options.forEach(function (option) {
            option.addEventListener('click', function () {
                selected.textContent = option.textContent;
                options.forEach(function (opt) {
                    return opt.classList.remove('active')
                });
                option.classList.add('active');
                customSelect.classList.remove('open');
                var value = option.getAttribute('data-value');
                document.querySelector('input[name="sort_by"]').value = value;
                if(window.matchMedia("(min-width: 768px)").matches) {
                    document.querySelector('input[name="sort_by"]')?.closest('form')?.dispatchEvent(new Event('input'));
                }else{
                   document.querySelector('input[name="sort_by"]')?.closest('form')?.dispatchEvent(new Event('submit'));
                }

            })
        });
        document.addEventListener('click', function (e) {
            if (!customSelect.contains(e.target)) {
                customSelect.classList.remove('open')
            }
        })
    }
    var customSelectFilter = document.querySelector('.reviews-filter-select-wrapper');
    if (customSelectFilter) {
        var _selected = customSelectFilter.querySelector('.js-opener-reviews-filter');
        var _options = customSelectFilter.querySelectorAll('.options li');
        _selected.addEventListener('click', function () {
            customSelectFilter.classList.toggle('open')
        });
        _options.forEach(function (option) {
            option.addEventListener('click', function () {
                _options.forEach(function (opt) {
                    return opt.classList.remove('active')
                });
                option.classList.add('active');
                customSelectFilter.classList.remove('open');
                var value = option.getAttribute('data-value');
                document.querySelector('input[name="sort_by"]').value = value
            })
        });
        document.addEventListener('click', function (e) {
            if (!customSelectFilter.contains(e.target)) {
                customSelectFilter.classList.remove('open')
            }
        })
    }
});
document.querySelectorAll('.accordion-header').forEach(function (header) {
    header.addEventListener('click', function () {
        var expanded = header.getAttribute('aria-expanded') === 'true';
        header.setAttribute('aria-expanded', !expanded);
        header.nextElementSibling.classList.toggle('open')
    })
});
var minRange = document.getElementById('minRange');
var maxRange = document.getElementById('maxRange');
var minInput = document.getElementById('minPrice');
var maxInput = document.getElementById('maxPrice');
var sliderRange = document.getElementById('sliderRange');
if (minRange && maxRange && minInput && maxInput && sliderRange) {
    var updateSliderTrack = function updateSliderTrack() {
        var minVal = parseInt(minRange.value);
        var maxVal = parseInt(maxRange.value);
        var percentMin = (minVal - absoluteMin) / (absoluteMax - absoluteMin) * 100;
        var percentMax = (maxVal - absoluteMin) / (absoluteMax - absoluteMin) * 100;
        sliderRange.style.left = percentMin + '%';
        sliderRange.style.width = percentMax - percentMin + '%'
    };
    var syncInputsFromSliders = function syncInputsFromSliders(e) {
        var minVal = parseInt(minRange.value);
        var maxVal = parseInt(maxRange.value);
        if (e.target === minRange && minVal > maxVal) {
            minRange.value = prevMin;
            return
        }
        if (e.target === maxRange && maxVal < minVal) {
            maxRange.value = prevMax;
            return
        }
        prevMin = minVal;
        prevMax = maxVal;
        minInput.value = minVal;
        maxInput.value = maxVal;
        updateSliderTrack()
    };
    var syncSlidersFromInputs = function syncSlidersFromInputs() {
        var minVal = parseInt(minInput.value);
        var maxVal = parseInt(maxInput.value);
        if (!isNaN(minVal) && !isNaN(maxVal) && minVal <= maxVal) {
            minRange.value = minVal;
            maxRange.value = maxVal;
            prevMin = minVal;
            prevMax = maxVal;
            updateSliderTrack()
        }
    };
    var absoluteMin = parseInt(minRange.min);
    var absoluteMax = parseInt(maxRange.max);
    var prevMin = parseInt(minRange.value);
    var prevMax = parseInt(maxRange.value);
    [minRange, maxRange].forEach(function (input) {
        return input.addEventListener('input', syncInputsFromSliders)
    });
    [minInput, maxInput].forEach(function (input) {
        return input.addEventListener('input', syncSlidersFromInputs)
    });
    updateSliderTrack()
}
var seoAccordions = document.querySelectorAll('.seo-text-wrapper-accordions-item');
if (seoAccordions.length > 0) {
    seoAccordions.forEach(function (item) {
        var itemHeader = item.querySelector('.seo-text-wrapper-accordions-item-header');
        var itemContent = item.querySelector('.seo-text-wrapper-accordions-item-content');
        itemHeader.addEventListener('click', function () {
            var isOpen = itemContent.classList.contains('active');// Close all accordions
            seoAccordions.forEach(function (otherItem) {
                var otherContent = otherItem.querySelector('.seo-text-wrapper-accordions-item-content');
                otherContent.classList.remove('active');
                otherItem.classList.remove('active')
            });// Toggle current one (re-open if it was closed)
            if (!isOpen) {
                itemContent.classList.add('active');
                item.classList.add('active')
            }
        })
    })
}
var mobileFilters = document.querySelector('.mobile-filter-button');
var filtersMenu = document.querySelector('.collection-grid-wrapper-filters');
var filterClose = document.querySelector('.mobile-filters-close');
if (mobileFilters && filtersMenu) {
    mobileFilters.addEventListener('click', function (e) {
        e.preventDefault();
        filtersMenu.classList.add('open')
    });
    filterClose.addEventListener('click', function (e) {
        e.preventDefault();
        filtersMenu.classList.remove('open')
    })
}// Hide filter
document.addEventListener('DOMContentLoaded', function () {
    var hideBtn = document.querySelectorAll('.collection-grid .hide-btn');
    var collectionGrid = document.querySelector('.collection-grid');
    if (!hideBtn.length || !collectionGrid) return;
    hideBtn.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            collectionGrid.classList.toggle('filters-hidden');
            hideBtn.forEach(function (item) {
                var span = item.querySelector('span');
                if (collectionGrid.classList.contains('filters-hidden')) {
                    span.textContent = window.translations.show_filter;// Show filters
                } else {
                    span.textContent = window.translations.hide_filter;// Hide filters
                }
            })
        })
    })
});
var initLazyLoad = function initLazyLoad() {
    var lazyLoadPromise = new Promise(function (resolve, reject) {
        var dataImages = document.querySelectorAll('img[data-src], source[data-srcset]');
        dataImages.forEach(function (img, i) {
            img.removeAttribute('src');
            if (img.getAttribute('data-srcset')) {
                img.removeAttribute('srcset');
                img.setAttribute('srcset', img.getAttribute('data-srcset'))
            } else {
                img.setAttribute('src', img.getAttribute('data-src'))
            }
            img.onload = function () {
                img.removeAttribute('data-src');
                img.removeAttribute('data-srcset')
            }
        });
        resolve()
    })
};
initLazyLoad();
document.addEventListener('DOMContentLoaded', function () {// Product Page
//product slider
    var productSwiperMob = null;

    function initProductSlider() {
        var slider = document.querySelector('.js-product-gallery-slider');
        var counter = document.querySelector('.product-gallery-counter');
        if (window.innerWidth <= 1023) {
            if (slider) {
                if (!productSwiperMob) {
                    productSwiperMob = new Swiper(slider, {
                        loop: false,
                        speed: 300,
                        slidesPerView: 1,
                        spaceBetween: 4.5,
                        navigation: {nextEl: null, prevEl: null},
                        on: {
                            init: function init() {
                                updateCounter(this, counter)
                            }, slideChange: function slideChange() {
                                updateCounter(this, counter)
                            }
                        }
                    })
                }
            }
        } else {
            if (productSwiperMob) {
                productSwiperMob.destroy(true, true);
                productSwiperMob = null
            }
        }
    }

    initProductSlider();
    window.addEventListener('resize', function () {
        initProductSlider()
    });
    var productGallery = document.querySelector('.product-gallery');
    addHeightProductTop();

    function addHeightProductTop() {
        var productTop = document.querySelector('.product-top');
        if (productTop) {
            if (productTop.clientHeight > productGallery.clientHeight) {
                productGallery.classList.add('align-top')
            }
            productTop.style.minHeight = 'auto'
        }
        syncThumbHeight()
    }

    // Keep the thumbnail column the same height as the main photo so it ends
    // the same distance from the bottom as it starts from the top (30px each).
    function syncThumbHeight() {
        var mainSlider = document.querySelector('.js-product-gallery-main-slider');
        var tabSlider = document.querySelector('.js-product-gallery-tab-slider');
        if (!mainSlider || !tabSlider) return;
        if (window.innerWidth < 1024) {
            tabSlider.style.height = '';
            tabSlider.style.maxHeight = '';
            return;
        }
        var mainHeight = mainSlider.clientHeight;
        if (mainHeight > 0) {
            tabSlider.style.height = (mainHeight - 60) + 'px';
            tabSlider.style.maxHeight = (mainHeight - 60) + 'px';
            if (tabSlider.swiper) tabSlider.swiper.update();
        }
    }

    window.addEventListener('resize', addHeightProductTop);
    var block = document.querySelector('.product-top-info');
    var originalContainer = document.querySelector('.product-top-main');
    var targetContainer = document.querySelector('.product-left');

    function moveBlock() {
        if (block) {
            if (window.innerWidth < 1023) {
                if (!targetContainer.contains(block)) {// targetContainer.insertBefore( block, targetContainer.firstChild );
                    block.classList.add('js-block')
                }
            } else {
                if (!originalContainer.contains(block)) {// originalContainer.insertBefore( block, originalContainer.firstChild );
                    block.classList.remove('js-block')
                }
            }
        }
    }

    if (targetContainer) {
        moveBlock();
        window.addEventListener('resize', moveBlock)
    }//product slider with tab
    function initProductSliderWithTab() {
        var sliderMain = document.querySelector('.js-product-gallery-main-slider');
        if (sliderMain) {
            var sliderTab = document.querySelector('.js-product-gallery-tab-slider');
            var counter = document.querySelector('.product-gallery-counter');
            var thumbs = new Swiper(sliderTab, {
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 8,
                speed: 200,
                direction: 'vertical',// freeMode: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                preventClicks: true,
                preventClicksPropagation: true
            });
            var productSlider = new Swiper(sliderMain, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 200,
                navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
                thumbs: {swiper: thumbs},
                pagination: {el: '.product-gallery-pagination', clickable: true},
                breakpoints: {0: {slidesPerView: 1, spaceBetween: 4.5}, 1024: {slidesPerView: 1, spaceBetween: 0}},
                on: {
                    init: function init() {
                        updateCounter(this, counter)
                    }, slideChange: function slideChange() {
                        updateCounter(this, counter);
                        var activeIndex = this.realIndex;
                        var thumbsWrapper = thumbs.wrapperEl;
                        var thumbsSlides = thumbs.slides;
                        var activeSlide = thumbsSlides[activeIndex];
                        if (activeSlide && thumbsWrapper) {
                            var containerHeight = thumbs.el.clientHeight;
                            var slideTop = activeSlide.offsetTop;
                            var slideHeight = activeSlide.offsetHeight;
                            var currentTranslate = thumbs.getTranslate();
                            var targetTranslate = -slideTop;// якщо превʼюшка нижче видимої області — доскролити вниз
                            if (slideTop + slideHeight > -currentTranslate + containerHeight) {
                                targetTranslate = -(slideTop - containerHeight + slideHeight)
                            }// обмежуємо скрол, щоб не виліз за межі (вручну)
                            var maxTranslate = 0;
                            var minTranslate = -(thumbsWrapper.scrollHeight - containerHeight);
                            if (targetTranslate > maxTranslate) targetTranslate = maxTranslate;
                            if (targetTranslate < minTranslate) targetTranslate = minTranslate;
                            thumbs.setTranslate(targetTranslate);
                            thumbs.updateActiveIndex(activeIndex);// щоб коректно активувався слайд
                        }
                    }
                }
            });
            var tabSlides = document.querySelectorAll('.js-product-gallery-tab-slider .swiper-slide');
            tabSlides.forEach(function (slide, index) {
                slide.addEventListener('click', function () {
                    productSlider.slideTo(index)
                })
            });// scrollToVideo(document.querySelector('.product-menu-item[href="#video"]'), ".product-gallery-main-slider", productSlider)
            const slideIndex = Array.from(sliderMain.querySelectorAll('.swiper-slide'))
                .findIndex(slide => slide.hasAttribute('data-initial'));
            if (slideIndex !== -1) {
                productSlider.slideTo(slideIndex);
            }
        }
    }

    initProductSliderWithTab();
    syncThumbHeight();
    window.addEventListener('load', syncThumbHeight);

    function updateCounter(swiper, counter) {
        var currentIndex = swiper.realIndex + 1;
        var totalSlides = swiper.slides.length;
        if (currentIndex === totalSlides) {
            counter.innerHTML = currentIndex + '/' + totalSlides
        } else {
            counter.innerHTML = currentIndex + '/' + totalSlides
        }
    }

    var quantityInput = document.querySelectorAll('.quantity');
    if (quantityInput.length) {
        quantityInput.forEach(function (quantity) {
            var plus = quantity.querySelector('.quantity-button--plus');
            var minus = quantity.querySelector('.quantity-button--minus');
            var input = quantity.querySelector('.quantity-input');
            var getMax = function () {
                var max = parseInt(input.getAttribute('max'), 10);
                return isNaN(max) ? null : max;
            };
            var refreshButtons = function () {
                var value = Number(input.value);
                var max = getMax();
                minus.classList.toggle('_disabled', value <= 1);
                if (max !== null) {
                    plus.classList.toggle('_disabled', value >= max);
                } else {
                    plus.classList.remove('_disabled');
                }
            };
            // Expose so the variant-change logic can clamp/refresh after updating max
            quantity.refreshQuantityButtons = refreshButtons;
            refreshButtons();
            if (plus) {
                plus.addEventListener('click', function () {
                    var max = getMax();
                    var value = Number(input.value);
                    if (max !== null && value >= max) return;
                    value++;
                    input.value = value;
                    refreshButtons()
                })
            }
            if (minus) {
                minus.addEventListener('click', function () {
                    var value = Number(input.value);
                    if (value > 1) {
                        value--;
                        input.value = value;
                        refreshButtons()
                    }
                })
            }
        })
    }// function isInViewport( element ) {
// 	const rect = element.getBoundingClientRect();
// 	let productHeadHeight = 0;
// 	return (
// 		rect.top >= productHeadHeight &&
// 		rect.left >= 0 &&
// 		rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) &&
// 		rect.right <= ( window.innerWidth || document.documentElement.clientWidth )
// 	);
// }
    function isPartiallyInViewport(element) {
        var rect = element.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > document.querySelector('header').clientHeight
    }// let element = document.querySelector( '.js-product-product-actions' );
    var bar = document.querySelector('.product-bar');
    var element = document.querySelector('.product');

    function checkVisibility() {
        document.querySelector('.wrapper').style.paddingBottom = bar.clientHeight + 'px';
        if (isPartiallyInViewport(element)) {
            bar.classList.add('hide')
        } else {
            bar.style.display = 'block';
            setTimeout(function () {
                bar.classList.remove('hide')
            }, 10)
        }
    }

    if (bar) {
        window.addEventListener('scroll', checkVisibility);
        checkVisibility()
    }//upsale-products-slider
    var upsaleProductsSlider = document.querySelectorAll('.upsale-products');
    if (upsaleProductsSlider.length) {
        upsaleProductsSlider.forEach(function (container) {
            var slider = container.querySelector('.upsale-products-swiper');
            var btnPrev = container.querySelector('.swiper-button-prev');
            var btnNext = container.querySelector('.swiper-button-next');
            var counter = container.querySelector('.counter');
            var sliderSwiper = new Swiper(slider, {
                loop: false,
                speed: 300,
                slidesPerView: 1,
                navigation: {nextEl: btnNext, prevEl: btnPrev},
                on: {
                    init: function init() {
                        counter.innerHTML = this.realIndex + 1 + ' / ' + this.slides.length
                    }, slideChange: function slideChange() {
                        counter.innerHTML = this.realIndex + 1 + ' / ' + this.slides.length
                    }
                }
            })
        })
    }
    document.addEventListener('click', function (e) {
        var link = e.target.closest('a[href*="#"]');
        if (link) {
            var blockID = link.getAttribute('href').substr(1);
            var _element = document.getElementById(blockID);
            if (_element) {
                e.preventDefault();
                if (blockID == 'video') {
                    if (document.querySelector('.product-gallery a.product-gallery-video')) {
                        document.querySelector('.product-gallery .product-gallery-video').click()
                    }
                    if (document.querySelector('.product-gallery .product-gallery-video + a')) {
                        document.querySelector('.product-gallery .product-gallery-video + a').click()
                    }
                    return
                }
                var offset = document.querySelector('.header').classList.contains('._scrolled') ? document.querySelector('.header').offsetHeight + document.querySelector('.product-head').offsetHeight : document.querySelector('.header-top').offsetHeight - 25 + document.querySelector('.product-head').offsetHeight;
                var elementRect = _element.getBoundingClientRect().top;
                var offsetPosition = window.scrollY + elementRect - offset;
                if (blockID == 'product-info') {
                    window.scrollTo({top: 0, behavior: 'smooth'})
                } else {
                    window.scrollTo({top: offsetPosition, behavior: 'smooth'})
                }
            }
        }
    });

    function initNav() {
        var nav = document.querySelector('.product-menu');
        if (nav) {
            if (window.innerWidth < 1023) {
                document.querySelector('.product-top').classList.remove('js-block');
                document.querySelector('.product-gallery').setAttribute('data-trigger', 'block-1');
                document.querySelector('.product-top').setAttribute('data-trigger', 'block-1')
            }
            var headings = document.querySelectorAll('.js-block');
            var navItems = nav.querySelectorAll('.js-btn');
            headings.forEach(function (heading, index) {
                var id = 'block-' + (index + 1);
                heading.setAttribute('data-trigger', id)
            });
            navItems.forEach(function (li, index) {
                var id = 'block-' + (index + 1);
                li.setAttribute('data-section', id)
            });
            // Highlight the last section scrolled past (not only while a heading
            // crosses the trigger line), so the underline never blanks out between
            // blocks and stays on the last tab (reviews) through the rest of the page.
            var validSections = Array.prototype.map.call(navItems, function (n) {
                return n.getAttribute('data-section');
            });
            var triggerLine = 200;
            function updateActiveNav() {
                var current = validSections[0];
                document.querySelectorAll('[data-trigger]').forEach(function (heading) {
                    var block = heading.getAttribute('data-trigger');
                    if (validSections.indexOf(block) !== -1 && heading.getBoundingClientRect().top <= triggerLine) {
                        current = block;
                    }
                });
                navItems.forEach(function (navItem) {
                    navItem.classList.toggle('active', navItem.getAttribute('data-section') === current);
                });
            }
            window.addEventListener('scroll', updateActiveNav);
            updateActiveNav();
        }
    }

    initNav();//products slider
    var productsSwipers = [];

    function initOrDestroyProductsSliders() {
        var productsSliders = document.querySelectorAll('.products-slider');
        if (!productsSliders.length) {
            return
        }
        productsSliders.forEach(function (productsWrapper, index) {
            // <product-recommendation> / <recently-viewed> sliders
            // self-initialize after their async fetch (see theme.js). Skip them
            // here to avoid a second Swiper fighting over the same container.
            if (productsWrapper.tagName === 'PRODUCT-RECOMMENDATION' ||
                productsWrapper.tagName === 'RECENTLY-VIEWED') {
                return
            }
            var slider = productsWrapper.querySelector('.products-slider-swiper');
            var btnPrev = productsWrapper.querySelector('.swiper-button-prev');
            var btnNext = productsWrapper.querySelector('.swiper-button-next');
            var scrollbar = slider.querySelector('.swiper-scrollbar');
            var perView = parseFloat(productsWrapper.getAttribute('data-slides-per-view')) || 4;
            if (window.innerWidth >= 768) {
                if (!productsSwipers[index]) {
                    productsSwipers[index] = new Swiper(slider, {
                        loop: false,
                        slidesPerView: perView,
                        spaceBetween: 14,
                        navigation: {nextEl: btnNext, prevEl: btnPrev},
                        scrollbar: {el: scrollbar, draggable: true, hide: false}
                    })
                }
            } else {
                if (productsSwipers[index]) {
                    productsSwipers[index].destroy(true, true);
                    productsSwipers[index] = null
                }
            }
        })
    }

    initOrDestroyProductsSliders();
    window.addEventListener('resize', function () {
        initOrDestroyProductsSliders()
    });// ініціалізація Fancybox
    var fancyboxElements = document.querySelectorAll('[data-fancybox]');
    if (fancyboxElements.length) {
        fancyboxElements.forEach(function (element) {
            element.addEventListener('click', function (event) {
                event.preventDefault();
                var items = Array.from(fancyboxElements).map(function (el) {
                    var item = {src: el.getAttribute('href'), type: el.dataset.type || 'image'};
                    // Pass real media dimensions so portrait videos aren't boxed into 16:9.
                    if (el.dataset.width && el.dataset.height) {
                        item.width = parseInt(el.dataset.width, 10);
                        item.height = parseInt(el.dataset.height, 10);
                        item.ratio = item.width / item.height;
                    }
                    return item;
                });
                $.fancybox.open(items, {
                    loop: true,
                    thumbs: {autoStart: true},
                    animationEffect: 'zoom',
                    transitionEffect: 'fade',
                    index: Array.from(fancyboxElements).indexOf(element)
                })
            })
        })
    }

    // "Video" menu item: scroll the inline gallery to the video slide instead of
    // opening the fullscreen lightbox. Bound in the capture phase (and with
    // preventDefault) so it beats Fancybox's href="#video" trigger and the hash jump.
    document.querySelectorAll('.product-menu .js-video-scroll').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var main = document.querySelector('.js-product-gallery-main-slider');
            if (!main) return;
            var swiper = main.swiper;
            if (swiper) {
                var slides = main.querySelectorAll('.swiper-slide');
                var idx = -1;
                slides.forEach(function (s, i) { if (s.querySelector('.product-gallery-video')) idx = i; });
                if (idx > -1) swiper.slideTo(idx);
            }
            // Scroll to the very top (the gallery lives there) — a fixed target,
            // so repeated clicks can't drift the page down.
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, true);
    });

    var reviewsItmes = document.querySelectorAll('.review-item');
    if (reviewsItmes.length) {
        reviewsItmes.forEach(function (item) {
            var itemBtn = item.querySelector('.btn-link');
            itemBtn && itemBtn.addEventListener('click', function () {
                item.classList.toggle('open')
            })
        })
    }

    function cropNameToDot(containerSelector) {
        var containers = document.querySelectorAll(containerSelector);
        containers.forEach(function (container) {
            var fullText = container.dataset.fullName;
            if (window.innerWidth <= 768) {
                container.textContent = fullText;
                while (container.scrollWidth > container.clientWidth && container.textContent.length > 0) {
                    container.textContent = container.textContent.slice(0, -1)
                }
                if (container.textContent.length < fullText.length) {
                    container.textContent = container.textContent.slice(0, -1) + '.'
                }
            } else {
                container.textContent = fullText
            }
        })
    }

    function handleResize() {
        cropNameToDot('.review-item-name .name')
    }

    window.addEventListener('DOMContentLoaded', handleResize);
    window.addEventListener('resize', handleResize);//popup
    var buttons = document.querySelectorAll('.js-open-popup');
    var popups = document.querySelectorAll('.popup');
    buttons && buttons.length && buttons.forEach(function (button) {
        var popup = document.getElementById(button.dataset.popup);
        popup && button.addEventListener('click', function () {
            popup.classList.add('open');
            setTimeout(function () {
                popup.classList.add('animation')
            }, 200);
            lockScrollbar();
            setTimeout(function () {
                var slideIndex = parseInt(button.dataset.slide, 10);
                if (slideIndex) {
                    initGallerySlider(slideIndex)
                }
                var reviewId = button.dataset.reviewId;
                var btnIdReview = document.querySelector('.review-item[data-review-id="' + reviewId + '"]');
                if (btnIdReview) {
                    var reviewsPopup = document.querySelectorAll('.review-item');
                    reviewsPopup.forEach(function (item) {
                        item.classList.remove('active');
                        btnIdReview.classList.add('active')
                    })
                }
                initChooseSlider()
            }, 200)
        })
    });

    function initGallerySlider(slideGo) {
        var galleryWrapper = document.querySelectorAll('.review-gallery-wrapper');
        if (galleryWrapper.length) {
            galleryWrapper.forEach(function (wrapper) {
                var sliderMain = wrapper.querySelector('.review-gallery-slider-main');
                var sliderTab = wrapper.querySelector('.review-gallery-slider-tabs');
                var counter = wrapper.querySelector('.counter');
                var btnNext = wrapper.querySelector('.swiper-button-next');
                var btnPrev = wrapper.querySelector('.swiper-button-prev');
                if (!sliderMain || !sliderTab) {
                    return
                }
                var tabs = new Swiper(sliderTab, {
                    loop: false,
                    slidesPerView: 6.25,
                    spaceBetween: 6,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    touchStartPreventDefault: false,
                    slideToClickedSlide: true,
                    allowTouchMove: false
                });
                var gallerySlider = new Swiper(sliderMain, {
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    initialSlide: slideGo,
                    navigation: {nextEl: btnNext, prevEl: btnPrev},
                    thumbs: {swiper: tabs},
                    on: {
                        init: function init() {
                            counter.innerHTML = this.realIndex + 1 + '/' + this.slides.length
                        }, slideChange: function slideChange() {
                            counter.innerHTML = this.realIndex + 1 + '/' + this.slides.length;
                            updateActiveReview(this)
                        }
                    }
                })
            })
        }
    }

    function updateActiveReview(swiperInstance) {
        var currentSlide = swiperInstance.slides[swiperInstance.activeIndex];
        var reviewId = currentSlide.dataset.reviewId;
        var allReviews = document.querySelectorAll('.review-item');
        allReviews.forEach(function (item) {
            if (item.dataset.reviewId === reviewId) {
                item.classList.add('active')
            } else {
                item.classList.remove('active')
            }
        })
    }

    popups && popups.length && popups.forEach(function (popup) {
        var close = popup.querySelector('.popup-close');
        var bg = popup.querySelector('.popup-bg');
        var closeButton = popup.querySelector('.popup-button-close');
        close && close.addEventListener('click', function () {
            popup.classList.remove('open');
            popup.classList.remove('animation');
            unlockScrollbar()
        });
        bg && bg.addEventListener('click', function () {
            popup.classList.remove('open');
            popup.classList.remove('animation');
            unlockScrollbar()
        });
        closeButton && closeButton.addEventListener('click', function () {
            popup.classList.remove('open');
            popup.classList.remove('animation');
            unlockScrollbar()
        })
    });
    var tabsSliderSections = document.querySelectorAll('.js-tabs-slider');
    if (tabsSliderSections.length) {
        var activeClass = '_active';
        var disabledTabClass = '_disabled';
        var swiperButtonDisabled = 'swiper-button-disabled';
        var tabsSliderSectionsInit = function tabsSliderSectionsInit(section) {
            var sliderNextButton = section.querySelector('.js-tabs-slider-next');
            var sliderPrevButton = section.querySelector('.js-tabs-slider-prev');
            var tabsButtons = section.querySelectorAll('.js-tabs-slider-tabs .js-tabs-slider-tab');
            var tabsBlocks = section.querySelectorAll('.js-tabs-slider-tab-content');
            var activeTab = [].concat(_toConsumableArray(tabsBlocks)).find(function (contentBlock) {
                return contentBlock.classList.contains(activeClass)
            });
            var sliders = {};
            var sliderOptions = {
                slidesPerView: 'auto',
                spaceBetween: 8,
                breakpoints: {768: {spaceBetween: 14}},
                navigation: {nextEl: sliderNextButton, prevEl: sliderPrevButton},
                watchOverflow: true
            };
            var getScrollBarOptions = function getScrollBarOptions(scrollbarElement) {
                return {
                    scrollbar: {
                        el: scrollbarElement, draggable: true, hide: false// snapOnRelease: false
                    }
                }
            };
            if (activeTab) {
                var activeTabId = activeTab.getAttribute('data-tab-id');
                var activeSliderElement = activeTab.querySelector('.js-tabs-slider-product-slider');
                if (activeSliderElement) {
                    var scrollbarElement = activeSliderElement.querySelector('.swiper-scrollbar');
                    sliders[activeTabId] = new Swiper(activeSliderElement, Object.assign({}, sliderOptions, getScrollBarOptions(scrollbarElement)))
                }
            }
            var updateNavButtons = function updateNavButtons(swiper) {
                if (!swiper) return;
                if (swiper.isBeginning) {
                    sliderPrevButton.classList.add(swiperButtonDisabled)
                } else {
                    sliderPrevButton.classList.remove(swiperButtonDisabled)
                }
                if (swiper.isEnd) {
                    sliderNextButton.classList.add(swiperButtonDisabled)
                } else {
                    sliderNextButton.classList.remove(swiperButtonDisabled)
                }
            };
            tabsButtons.forEach(function (button) {
                button.addEventListener('click', function () {
                    if (button.classList.contains(activeClass) || button.classList.contains(disabledTabClass)) {
                        return
                    }
                    var buttonTabTarget = button.getAttribute('data-tab-target');
                    if (!buttonTabTarget) {
                        return
                    }
                    tabsButtons.forEach(function (btn) {
                        return btn.classList.remove(activeClass)
                    });
                    tabsBlocks.forEach(function (block) {
                        return block.classList.remove(activeClass)
                    });
                    if (sliderNextButton) {
                        sliderNextButton.classList.remove(swiperButtonDisabled)
                    }
                    if (sliderPrevButton) {
                        sliderPrevButton.classList.remove(swiperButtonDisabled)
                    }
                    button.classList.add(activeClass);
                    var currentContentBlock = [].concat(_toConsumableArray(tabsBlocks)).find(function (contentBlock) {
                        var constTabId = contentBlock.getAttribute('data-tab-id');
                        return constTabId === buttonTabTarget
                    });
                    if (currentContentBlock) {
                        currentContentBlock.classList.add(activeClass);
                        var sliderElement = currentContentBlock.querySelector('.js-tabs-slider-product-slider');
                        if (!sliders[buttonTabTarget]) {
                            var _scrollbarElement = sliderElement.querySelector('.swiper-scrollbar');
                            sliders[buttonTabTarget] = new Swiper(sliderElement, Object.assign({}, sliderOptions, getScrollBarOptions(_scrollbarElement)));
                            updateNavButtons(sliders[buttonTabTarget])
                        } else {
                            setTimeout(function () {
                                sliders[buttonTabTarget].update();
                                sliders[buttonTabTarget].slideTo(0);
                                updateNavButtons(sliders[buttonTabTarget])
                            }, 50)
                        }
                        activeTab = currentContentBlock
                    }
                })
            })
        };
        tabsSliderSections.forEach(function (section) {
            return tabsSliderSectionsInit(section)
        })
    }
    var passwordBlocks = document.querySelectorAll('.form-field-password');
    passwordBlocks && passwordBlocks.forEach(function (passwordBlock) {
        var passwordInputs = passwordBlock.querySelectorAll('input');
        var passwordIcon = passwordBlock.querySelector('.form-field-type-btn');
        passwordIcon && passwordIcon.addEventListener('click', function (e) {
            passwordIcon.classList.toggle('active');
            passwordInputs.forEach(function (input) {
                if (input.type === 'password') {
                    input.type = 'text'
                } else {
                    input.type = 'password'
                }
            })
        })
    });
    var input = document.querySelector('[type=\'tel\']');
    if (input) {
        var iti = window.intlTelInput(input, {
            initialCountry: 'auto',
            formatOnDisplay: true,
            nationalMode: false,
            utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js',// optional if not using the "WithUtils" build
            geoIpLookup: function geoIpLookup(callback) {
                fetch('https://ipapi.co/json').then(function (res) {
                    return res.json()
                }).then(function (data) {
                    return callback(data.country_code)
                }).catch(function () {
                    return callback('US')
                })
            }
        });
        input.addEventListener('keypress', function (e) {
            var key = e.key;
            var value = input.value;
            if (/[0-9]/.test(key)) return;
            if (key === '+' && value.length === 0 && !value.includes('+')) return;
            e.preventDefault()
        });
        input.addEventListener('paste', function (e) {
            var paste = (e.clipboardData || window.clipboardData).getData('text');
            if (!/^\+?\d+$/.test(paste)) {
                e.preventDefault()
            }
        });
        input.addEventListener('blur', function () {
            if (iti.isValidNumber()) {
                input.value = iti.getNumber()
            }
        })
    }
    var buttonsCopy = document.querySelectorAll('.copy-button');
    buttonsCopy && buttonsCopy.length && buttonsCopy.forEach(function (button) {
        var content = button.dataset.copy;
        content && button.addEventListener('click', function () {
            navigator.clipboard.writeText(content)
        })
    });
    //account status info
    var accountStatus = document.querySelector('.account-info-status');
    if (accountStatus) {
        var closeBtn = accountStatus.querySelector('.close');
        closeBtn.addEventListener('click', function () {
            accountStatus.classList.add('hidden')
        });
        setTimeout(function () {
            if (accountStatus.classList.contains('visible')) {
                accountStatus.classList.add('hidden')
            }
        }, 20000)
    }// account menu
    var buttonsOpenerAccountMenu = document.querySelectorAll('.js-open-account-menu');
    buttonsOpenerAccountMenu && buttonsOpenerAccountMenu.length && buttonsOpenerAccountMenu.forEach(function (btn) {
        var accountContent = document.querySelector('.account-main');
        var accountMenu = document.querySelector('.account-menu');
        var accountHead = document.querySelector('.account-head');
        btn.addEventListener('click', function () {
            accountContent.classList.add('hide');
            accountMenu.classList.add('open');
            accountHead.classList.add('open')
        })
    });
    var rowsFeatures = document.querySelectorAll('.features-row');
    if (rowsFeatures.length && window.innerWidth <= 1200) {
        rowsFeatures.forEach(function (item) {
            item.innerHTML += item.innerHTML
        })
    }//announcement-bar
    var announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
        var closeAnnouncementBar = announcementBar.querySelector('.js-close-announcement-bar');
        closeAnnouncementBar.addEventListener('click', function () {
            announcementBar.classList.add('hide');
            sessionStorage.setItem('announcementBarClosed', 'true');
            setTimeout(function () {
                recalcHeaderHeightVar()
            }, 301)
        })
    }//init choose popup slider
    function initChooseSlider() {
        var sliderChoosePopup = document.querySelector('.choose-option-popup-main-slider');
        if (sliderChoosePopup) {
            var sliderThumb = document.querySelector('.choose-option-popup-thumbs');
            var counter = document.querySelector('.choose-option-popup-counter');
            var thumb = new Swiper(sliderThumb, {
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 8,
                speed: 200,
                direction: 'vertical',
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                preventClicks: true,
                preventClicksPropagation: true
            });
            var chooseSlider = new Swiper(sliderChoosePopup, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 200,
                navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
                thumbs: {swiper: thumb},
                breakpoints: {0: {slidesPerView: 1, spaceBetween: 4.5}, 1024: {slidesPerView: 1, spaceBetween: 0}},
                on: {
                    init: function init() {
                        updateCounter(this, counter)
                    }, slideChange: function slideChange() {
                        updateCounter(this, counter);
                        var activeIndex = this.realIndex;
                        var thumbsWrapper = thumb.wrapperEl;
                        var thumbsSlides = thumb.slides;
                        var activeSlide = thumbsSlides[activeIndex];
                        if (activeSlide && thumbsWrapper) {
                            var containerHeight = thumb.el.clientHeight;
                            var slideTop = activeSlide.offsetTop;
                            var slideHeight = activeSlide.offsetHeight;
                            var currentTranslate = thumb.getTranslate();
                            var targetTranslate = -slideTop;
                            if (slideTop + slideHeight > -currentTranslate + containerHeight) {
                                targetTranslate = -(slideTop - containerHeight + slideHeight)
                            }
                            var maxTranslate = 0;
                            var minTranslate = -(thumbsWrapper.scrollHeight - containerHeight);
                            if (targetTranslate > maxTranslate) targetTranslate = maxTranslate;
                            if (targetTranslate < minTranslate) targetTranslate = minTranslate;
                            thumb.setTranslate(targetTranslate);
                            thumb.updateActiveIndex(activeIndex)
                        }
                    }
                }
            });
            var thumbSlides = document.querySelectorAll('.choose-option-popup-thumbs .swiper-slide');
            thumbSlides.forEach(function (slide, index) {
                slide.addEventListener('click', function () {
                    chooseSlider.slideTo(index)
                })
            })
        }
    }
});
var reviewForm = document.querySelector('.write-review-form');
if (reviewForm) {
    var rating = reviewForm.querySelector('.write-review-rating');
    if (rating) {
        var ratingInput = rating.querySelector('input[name="rating"]');
        var allStars = Array.from(document.querySelectorAll('.star'));
        if (ratingInput) {
            ratingInput.value = ''
        }
        allStars && allStars.length && allStars.forEach(function (star, index) {
            var previous = allStars.slice(0, index + 1);// +1 щоб включити саму зірку
            star.addEventListener('mouseenter', function () {
                previous.forEach(function (prev) {
                    return prev.classList.add('hover')
                })
            });
            star.addEventListener('mouseleave', function () {
                previous.forEach(function (prev) {
                    return prev.classList.remove('hover')
                })
            });
            star.addEventListener('click', function () {
                allStars.forEach(function (item) {
                    return item.classList.remove('hover', 'active')
                });
                previous.forEach(function (prev) {
                    return prev.classList.add('active')
                });
                if (ratingInput) {
                    ratingInput.value = star.dataset.rating
                }
            })
        })
    }
}
//# sourceMappingURL=app.js.map
